"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _reactJss = require("react-jss");

var _variables = require("../../styles/variables");

// import { globalStyles } from "../../styles/global";
var useStyles = (0, _reactJss.createUseStyles)({
  // ...globalStyles,
  loadingBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  loading: {
    backgroundColor: _variables.colors.father,
    borderRadius: "100%",
    boxShadow: "-1em 0 0#7300A8, 1em 0 0#7300A8",
    display: "block",
    height: "10px",
    width: "10px",
    animation: "loading 700ms linear infinite",
    animationName: "$loading"
  },
  "@keyframes loading": {
    "0%": {
      backgroundColor: "transparent",
      boxShadow: "-1em 0 0 transparent, 1em 0 0 transparent"
    },
    "20%": {
      backgroundColor: "transparent",
      boxShadow: "-1em 0 0#7300A8, 1em 0 0 transparent"
    },
    "40%": {
      backgroundColor: _variables.colors.father,
      boxShadow: "-1em 0 0#7300A8, 1em 0 0 transparent"
    },
    "60%": {
      backgroundColor: _variables.colors.father,
      boxShadow: "-1em 0 0 transparent, 1em 0 0#7300A8"
    },
    "80%": {
      backgroundColor: "transparent",
      boxShadow: "-1em 0 0 transparent, 1em 0 0#7300A8"
    },
    "100%": {
      backgroundColor: "transparent",
      boxShadow: "-1em 0 0 transparent, 1em 0 0 transparent"
    }
  }
}, {
  name: 'pds-loading'
});
exports.useStyles = useStyles;